import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { formatCurrency } from "@/lib/product";

/** Melding zolang het minimum bestelbedrag niet gehaald is. */
export const MinimumOrderAlert = ({ minimum, ontbreekt, gehaald, testId = "minimum-order-alert" }) => {
  const { t, i18n } = useTranslation();
  if (!minimum || gehaald) return null;
  return (
    <Alert
      className="mb-4 border-[hsl(var(--warning))]/30 bg-[hsl(var(--warning))]/10"
      data-testid={testId}
    >
      <AlertTriangle className="h-4 w-4 text-[hsl(var(--warning))]" aria-hidden="true" />
      <AlertDescription>
        {t("cart.minimumHint", {
          ontbreekt: formatCurrency(ontbreekt, i18n.language),
          minimum: formatCurrency(minimum, i18n.language),
        })}
      </AlertDescription>
    </Alert>
  );
};
